import { create, select } from 'd3-selection';
import { scaleLinear } from 'd3-scale';
import { range } from 'd3-array';
import { axisBottom } from 'd3-axis';
import { format } from 'd3-format';

const d3 = {
  create, select, scaleLinear, range, axisBottom, format
};
export default class Legend {
  constructor(options) {
    this.threshold = options.threshold;
    this.max = options.max;
    this.render();
  }
  render(options) {
    const threshold = this.threshold;
    const width = 300,
      height = 30,
      legendSize = 8,
      tickSize = 13,
      margin = {
        left: 2,
        top: 0
      };

    const svg = d3.create('svg')
      .attr('width', width)
      .attr('height', height);

    const g = svg.append('g')
      .attr('transform', `translate(${ margin.left },0)`);

    const x = d3.scaleLinear()
      .domain([365,1521])
      .range([0, width]);

    const xAxis = d3.axisBottom(x)
      .tickSize(tickSize)
      .tickValues(threshold.domain())
      .tickFormat(d => {
        const years = d/365;
        if (years == 3) {
          return '3+';
        } else if (d % 365 == 0) {
          return years;
        } else {
          return d3.format('.1f')(years);
        }
      });

    g.call(xAxis);

    g.select('.domain')
      .remove();

    g.selectAll('rect')
      .data(threshold.range().map(function(color) {
        const d = threshold.invertExtent(color);
        if (d[0] == null) d[0] = x.domain()[0];
        if (d[1] == null) d[1] = x.domain()[1];
        return d;
      }))
      .enter().insert('rect', '.tick')
        .attr('height', legendSize)
        .attr('x', function(d) { return x(d[0]); })
        .attr('width', function(d) { return x(d[1]) - x(d[0]); })
        .attr('fill', function(d) { return threshold(d[0]); });

    return svg.node();
  }
}